// extracted by mini-css-extract-plugin
export default {"flag":"style_flag__312kG","reverseBorder":"style_reverseBorder__RlmAJ"};